import React, { useState } from "react";
import { Modal, Input } from "antd";
import Alert from "./GxAlert";

/**
 * مودال دریافت PIN مدیر برای عملیات حساس.
 * props:
 *   open, onCancel
 *   onConfirm(pin)  — با PIN واردشده فراخوانی می‌شود
 *   title، description
 */
export default function AdminPinModal({ open, onCancel, onConfirm, title = "کد مدیریتی", description }) {
  const [pin, setPin] = useState("");

  const handleOk = () => {
    onConfirm(pin);
    setPin("");
  };
  const handleCancel = () => {
    setPin("");
    onCancel();
  };

  return (
    <Modal
      title={`⚠ ${title}`}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="تایید"
      cancelText="انصراف"
      okButtonProps={{ danger: true }}
      width={420}
    >
      <Alert
        type="warning"
        showIcon
        message={description || "این عملیات روی رکورد تاییدشده انجام می‌شود و نیاز به کد مدیریتی دارد."}
        style={{ marginBottom: 16 }}
      />
      <div style={{ direction: "rtl" }}>
        <label style={{ display: "block", marginBottom: 6, fontWeight: 600 }}>کد مدیریتی:</label>
        <Input.Password
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          onPressEnter={handleOk}
          placeholder="کد مدیریتی"
          autoFocus
        />
      </div>
    </Modal>
  );
}
